import { useState, useEffect } from "react";
import SectionHeader from "../../../components/sectionHeader/sectionHeader";
import Tabs from "../../../components/tabs/tabs";
import { Usuarios } from "./pages/usuarios/usuarios";
import { Empresas } from "./pages/empresas/empresas";
import { getApiInstance } from "../../../utils/api"; 

import "./usuarios.scss";

export default function GestionUsuarios() {
    const [activeTab, setActiveTab] = useState("usuarios");
    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {
        fetchCurrentUser();
    }, []);

    const fetchCurrentUser = async () => {
        const api = getApiInstance();
        try {
            const response = await api.get("/api/Usuario/GetCurrentUserWithEmpresa"); 
            setCurrentUser(response.data);
        } catch (error) {
            console.error("Error al obtener usuario actual:", error);
        }
    };    

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
    };

    return (
        <section className="dashboard-usuarios">
            <SectionHeader
                title="Panel de Administrador - Gestión de usuarios y empresas"
                subtitle="En esta pantalla podrás ver y gestionar todos los usuarios y las empresas de la aplicación"
            />

            {/* <Tabs
                tabs={[
                    { id: "usuarios", label: "Usuarios" },
                    ...((currentUser?.codTipoEmpresa !== 3 && currentUser?.codTipoEmpresa !== 2)
                        ? [{ id: "empresas", label: "Empresas" }]
                        : []), // Si es proveedor, no se añade la pestaña Empresas
                ]}
                activeTab={activeTab}
                onTabChange={handleTabChange}
            /> */}
            <Tabs
                tabs={[
                    { id: "usuarios", label: "Usuarios" },
                    ...((![2, 3, 4].includes(currentUser?.codTipoEmpresa))
                        ? [{ id: "empresas", label: "Empresas" }]
                        : []), // Solo usuarios que NO sean proveedor (2), cliente (3) ni estudios (4)
                ]}
                activeTab={activeTab}
                onTabChange={handleTabChange}
            />


            <div className="dashboard-usuarios__content">
                {activeTab === "usuarios" && <Usuarios />}

                {/* {activeTab === "empresas" && currentUser?.codTipoEmpresa !== 3 && currentUser?.codTipoEmpresa !== 2 && <Empresas />} */}
                {activeTab === "empresas" && ![2, 3, 4].includes(currentUser?.codTipoEmpresa) && <Empresas />}
            </div>
        </section>
    );
}